import { render, staticRenderFns } from "./authorize_access.vue?vue&type=template&id=2a9969e0&scoped=true"
import script from "./authorize_access.vue?vue&type=script&lang=js"
export * from "./authorize_access.vue?vue&type=script&lang=js"
import style0 from "./authorize_access.vue?vue&type=style&index=0&id=2a9969e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9969e0",
  null
  
)

export default component.exports